import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const fetchCompositionList =
	(params = '?page=0&Size=1000') =>
	async (dispatch) => {
		await ApiClient.GET('getFabricCompositions', params).then((response) => {
			dispatch({
				type: Types.FETCH_COMPOSITION_LIST,
				payload: response.data
			});
		});
	};
